import React, {
	createContext, useCallback, useContext, useLayoutEffect, useMemo, useState,
} from 'react';

import { MyThemeContext } from '../context/theme-context';

export const NEW_RESULTS_THEME_STORAGE_KEY = 'new-results-theme-v1';

const NewResultsThemeContext = createContext(null);

export function readStoredNewResultsTheme() {
	if (typeof window === 'undefined') return 'light';
	return localStorage.getItem(NEW_RESULTS_THEME_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
}

function applyThemeToDocument(theme) {
	if (typeof document === 'undefined') return;
	document.documentElement.dataset.nrTheme = theme;
}

export function NewResultsThemeProvider({ children }) {
	const { setThemeState } = useContext(MyThemeContext);
	const [theme, setTheme] = useState(readStoredNewResultsTheme);

	useLayoutEffect(() => {
		applyThemeToDocument(theme);
		setThemeState(theme === 'dark');
		try {
			localStorage.setItem(NEW_RESULTS_THEME_STORAGE_KEY, theme);
		} catch {
			/* quota / mode privé */
		}
	}, [theme, setThemeState]);

	const toggleTheme = useCallback(() => {
		setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
	}, []);

	const value = useMemo(() => ({
		theme,
		setTheme,
		toggleTheme,
		isDark: theme === 'dark',
	}), [theme, toggleTheme]);

	return (
		<NewResultsThemeContext.Provider value={value}>
			{children}
		</NewResultsThemeContext.Provider>
	);
}

export function useNewResultsTheme() {
	const ctx = useContext(NewResultsThemeContext);
	if (!ctx) {
		throw new Error('useNewResultsTheme doit être utilisé dans NewResultsThemeProvider');
	}
	return ctx;
}

if (typeof document !== 'undefined') {
	applyThemeToDocument(readStoredNewResultsTheme());
}

/** Applique le thème stocké au montage (hors provider, ex. modale MUI). */
export function useSyncNewResultsThemeDocument() {
	const theme = readStoredNewResultsTheme();
	useLayoutEffect(() => {
		applyThemeToDocument(theme);
	}, [theme]);
}
